import axios from "axios";
import Config from "@/config"

export default class AccountService {
  getUserinfo(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{
        // "pippo": "pappo"
      }}
    };
    return axios
      .get(
        Config.proxy + Config.url("account") + "/user-info",
        options
      )
      .then(res => res.data.body);
    // console.log("AccessToken: " + accesstoken);
    // return axios
    //   .get(
    //     "stubs/get_userinfo.json",
    //   )
    //   .then(res => res.data.body);
  }
  putUserinfo(accesstoken, data) {
    const options = {
      headers: {
        ...Config.headers(accesstoken), ...{
        }
      }
    };
    return axios
      .put(
        Config.proxy + Config.url("account") + "/user-info", data,
        options
      )
      .then(res => res.data);
    // console.log("AccessToken: " + accesstoken);
    // console.log("Data: " + JSON.stringify(data));
    // return axios
    //   .get(
    //     "stubs/put_userinfo.json",
    //   )
    //   .then(res => res.data.body);
  }
  getCompany(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("account") + "/company",
        options
      )
      .then(res => res.data.body);
  }
  putCompany(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("account") + "/company", data,
        options
      )
      .then(res => res.data);
  }
  addUserWithGraph(data) {
    const options = {
      headers: { ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("account") + "/graph/users", data,
        options
      )
      .then(res => res.data);
  }
  resetPassword(email) {
    const options = {
      headers: { ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("account") + "/graph/resetPassword/" + email, null,
        options
      )
      .then(res => res.data);
  }
  changePassword(email, token, password) {
    const options = {
      headers: { ...{
        "verification-code": token,
        "new-password": password
      } }
    };
    return axios
    .post(
      Config.proxy + Config.url("account") + "/graph/changePassword/" + email, null,
        options
        )
        .then(res => res.data);
  }
  updatePassword(accesstoken, oldPassword, newPassword) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .patch(
      Config.proxy + Config.url("account") + "/users/password", {
        password: newPassword,
        oldPassword: oldPassword
      }, 
      options
      )
      .then(res => res.data);
  }
  checkVerificationCode(accesstoken, verificationCode) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("account") + "/verification-code/check?code="+verificationCode, null, 
      options
      )
      .then(res => res.data);
  }
  resendVerificationCode(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("account") + "/verification-code/resend", null, 
      options
      )
      .then(res => res.data);
  }
  getFaq(locale) {
    return axios
    .get(
      "json/faq/faq_"+locale+".json",
      )
      .then(res => res.data);
    }
  getFactoryUsers(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("account") + "/factory/users" + (serialNumber!=null?"?serialNumber=" + serialNumber:""),
        options
      )
      .then(res => res.data);
  }
  getFactoryUsersFilter(accesstoken, serialNumber, filters, pagination) {
    // if(Config.mock) {
    //   return axios
    //   .get(
    //     "stubs/get_factory_users.json",
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    let params = { 
      page: pagination?.first / pagination?.rows,
      nRows: pagination?.rows,
      filterAttributes: [],
      orderAttr: "email",
      ascOrDesc: true
    } 
    
    if(serialNumber) { params.filterAttributes.push({ "attribute": "serialNumber", "value": serialNumber }); }
    if(filters.global?.value) { params.filterAttributes.push({ "attribute": "freeSearch", "value": filters.global?.value }); }
    if(filters.role?.value) { params.filterAttributes.push({ "attribute": "role", "value": filters.role?.value }); }
    if(filters.country?.value) { params.filterAttributes.push({ "attribute": "country", "value": filters.country?.value }); }

    return axios
      .post(
        Config.proxy + Config.url("account") + "/factory/filter/users",
        params,
        options
      )
      .then(res => res.data);
  }
  deleteUser(accesstoken, email) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("account") + "/factory/users/" + email,
        options
      )
      .then(res => res.data.body);
  }
  getNotifications(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //   .get(
    //     "stubs/get_notifications.json",
    //     )
    //     .then(res => res.data.body);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .get(
      Config.proxy + Config.url("account") + "/notifications",
      options
    )
    .then(res => res.data.body);
  }
  getNotificationsV2(accesstoken, timestamp) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .get(
      Config.proxy + Config.url("account_v2") + "/notifications?startTimestamp=" + timestamp,
      options
    )
    .then(res => res.data.body);
  }
  getNotificationsCounter(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .get(
      Config.proxy + Config.url("account") + "/notifications/counter",
      options
    )
    .then(res => res.data.body);
  }
  getNotificationsCounterV2(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .get(
      Config.proxy + Config.url("account_v2") + "/notifications/counter",
      options
    )
    .then(res => res.data.body);
  }
  getAllServices(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .get(
      Config.proxy + Config.url("account") + "/services",
      options
    )
    .then(res => res.data.body);
  }
  downloadNotifications(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
    .get(
      Config.proxy + Config.url("account") + "/notifications/download",
      options
    )
    .then(res => res.data);
  }
  downloadNotificationsV2(accesstoken, timestamp) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
    .get(
      Config.proxy + Config.url("account_v2") + "/notifications/download?startTimestamp=" + timestamp,
      options
    )
    .then(res => res.data);
  }
  setNotificationsRead(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("account") + "/notifications/read", null,
      options
    )
    .then(res => res.data);
  }
  setNotificationsReadV2(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("account_v2") + "/notifications/read", null,
      options
    )
    .then(res => res.data);
  }
  selfDeleteUser(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("account") + "/users",
        options
      )
      .then(res => res.data);
  }
  upgradeUser(accesstoken, email, role) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("account") + "/factory/upgrade/" + email +"?targetRole="+role, null,
        options
      )
      .then(res => res.data);
  }
  getAllDomains(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    return axios
    .get(
      Config.proxy + Config.url("account") + "/factory/domains",
      options
    )
    .then(res => res.data);
  }
  saveAdvFeatures(accesstoken, email, chatbot, seller) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
    };
    return axios
    .post(
      Config.proxy + Config.url("account") + "/factory/features/" + email + "?chatbot=" + chatbot + (seller !== null ? "&seller=" + seller : ""), null,
      options
    )
    .then(res => res.data);
  }
}
